/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Main from '../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import CustomTable from '../../../components/common/CustomTable';
import { clearUserListData, fetchUserList, selectUserListData, setUserListData, updateUser } from '../../../store/slices/api/inner/userlistSlice';
import { formateDate } from '../../../components/common/FormateDate';
import Switch from '../../../components/common/Switch';
import TableAction from '../../../components/TableAction';
import { selectSelectedUser, toggleUserSlide } from '../../../store/slices/common';
import UsersForm from '../../../components/pages/UsersForm';
import avatar from '../../../assets/images/avatar.png'
import { socket } from '../../../socket';
import { FiMessageCircle } from 'react-icons/fi';
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchUserChats,
  selectUserChatLoading,
  selectUserChats,
} from "../../../store/slices/api/inner/chatSlice";
import { selectLoggedInData } from "../../../store/slices/api/auth/loginSlice";

export const UserListPage = () => {
  const loggedInData = useSelector(selectLoggedInData);

  const userListData = useSelector(selectUserListData);
  const dispatch = useDispatch();
  const userChats = useSelector(selectUserChats);
  const chatLoading = useSelector(selectUserChatLoading);
  const [userTyping, setUserTyping] = useState(false);
  const typingTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const selectedUsers = useSelector(selectSelectedUser);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const chatRef = useRef(null);

  // Handling redirect from notifications
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userIdFromQuery = searchParams.get("user_id");
  const isAnonymousFromQuery = searchParams.get("isAnonymous")==="true";

  // Smooth Scroll to latest message
  useEffect(() => {
    chatRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, userTyping]);

  useEffect(() => {
    if (userIdFromQuery && userListData.length > 0) {
      if (!isAnonymousFromQuery) {
        const userToChat = userListData.find(
          (user) => String(user.user_id) === userIdFromQuery
        );
        if (userToChat) {
          openChat(userToChat);
        }
      } else {
        const userToChat = {
          name: `Anonymous_User_${userIdFromQuery}`,
          email: null,
          user_id: Number(userIdFromQuery),
        };
        openChat(userToChat);
      }
    }
  }, [userIdFromQuery, userListData, isAnonymousFromQuery]);

  useEffect(() => {
    if (userChats.length > 0) {
      setMessages(userChats);
    }
  }, [userChats]);

  const openChat = async (user) => {
    setSelectedUser(user);
    setIsChatOpen(true);
    setMessages([]);

    // Fetch chat messages of opened chat
    dispatch(fetchUserChats({userId:user.user_id,isAnonymous:isAnonymousFromQuery}));

    socket.emit("adminJoined", { user_id: user.user_id });
  };
    const { handleSubmit: fetchData } = useApiRequest({
        apiAction: fetchUserList,
        setValueAction: setUserListData,
        clearValueActionOnError: clearUserListData,
        isForm: false,
        successMessage: false,
    });

    const afterUpdateApiCall = (res) => {
      fetchData()
    }
  
    const { handleSubmit: handleUpdate } = useApiRequest({
      apiAction: updateUser,
      clearForm: false,
      isForm: false,
      successMessage: false,
      afterAPICall: afterUpdateApiCall,
    });

    

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
      if (loggedInData?.authUserData) {
        const { admin_id } = loggedInData?.authUserData;
        socket.emit("joinRoom", { user_id: admin_id, is_admin: true });
      }

      socket.on("receiveMessage", (newMessage) => {
        setMessages((prev) => [...prev, newMessage]);
      });

      socket.on("userTypingStatus", ({ user_id, isTyping }) => {
        if (selectedUser && selectedUser.user_id === Number(user_id)) {
          setUserTyping(isTyping);
        }
      });

      return () => {
        socket.off("receiveMessage");
        socket.off("userTypingStatus");

        // Clear any existing typing timeout
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current);
        }
      };
    }, [loggedInData]);

    const sendMessage = () => {
      if (!selectedUser || message.trim() === "") return;
      socket.emit("sendAdminMessage", {
        user_id: selectedUser.user_id,
        message,
        message_type: "text",
        isAnonymousUser: isAnonymousFromQuery
      });

      setMessage("");

      // Clear typing indicator when sending a message
      socket.emit("adminTyping", {
        user_id: selectedUser.user_id,
        isTyping: false,
      });
    };

  const closeChat = () => {
    if (selectedUser)
      socket.emit("adminLeft", { user_id: selectedUser.user_id });
    setIsChatOpen(false);
    setSelectedUser(null);
    setMessages([]);
    // Remove `user_id` from URL query params
    navigate("/user-list");
  };

    const handleEdit = (data) => {
      dispatch(setSelectedUser(data));
      dispatch(toggleUserSlide());
    }

    const columns = useMemo(() => [
      {
        accessorKey: 'name',
        cell: info => `${info.row.original.name} ${info.row.original.surname}`,
        filterFn: 'includesStringSensitive',
      },
      {
        accessorKey: 'email',
        cell: info => <span>{info.row.original.email}<br />{info.row.original.phone || ''}</span>,
        filterFn: 'includesStringSensitive',
        header: "Contacts"
      },
      {
        accessorKey: 'createdAt',
        cell: info => formateDate(info.getValue()),
        filterFn: 'includesStringSensitive',
        header: "registration date"
      },
      {
        accessorKey: 'profile_pic',
        cell: info => <div className='h-20 w-28 flex items-center justify-center'>
          <img src={(!info.getValue() || info.getValue==='null') ? avatar : `${process.env.REACT_APP_BASE_URL}/assets/${info.getValue()}`} className='w-[60px]' style={{borderRadius:"10px"}} alt='user' />
        </div>,
        header: "profile image"
      },
      {
        accessorKey: 'membership_type',
        cell: info => <span>{info.getValue()}<br/><b>Country : </b> {info.row.original.location ? JSON.parse(info?.row?.original?.location)?.label : 'N/A'}</span>,
        filterFn: 'includesStringSensitive',
        header: "membership type"
      },
      {
        accessorKey: 'activated_plan',
        cell: info => <span>{info.getValue()}</span>,
        filterFn: 'includesStringSensitive',
        header: "activated plan"
      },
      {
        id: "chat",
        cell: (info) => (
            <button onClick={() => openChat(info.row.original)}>
                <FiMessageCircle size={24} color="green" />
            </button>
        ),
        header: () => <span>Chat</span>,
    },
      {
        accessorKey: 'user_status',
        cell: info => {
          const isActive = info.getValue() === 'active';
          return (
            <Switch onChange={() => { handleUpdate({ formData: { userStatus: isActive ? 'inactive' : 'active' }, query: { usersId: info.row.original.user_id } }) }} checked={isActive ? true : false} />
          );
        },
        filterFn: 'includesStringSensitive',
        header: "Status"
      },
      {
        accessorKey: 'next_billing_date',
        cell: info => info.getValue() ? formateDate(info.getValue()) : 'N/A',
        filterFn: 'includesStringSensitive',
        header: <span className='w-24'>next billing date</span>
      },
      {
        accessorKey: 'deletedAt',
        cell: info => <span className={`${info.getValue() ? 'text-red-800 border-red-400 bg-red-100' : 'text-green-800 border-green-400 bg-green-100'} text-xs font-medium me-2 px-2.5 py-0.5 rounded border`}>{info.getValue() ? formateDate(info.getValue()) : "Registered"}</span>,
        filterFn: 'includesStringSensitive',
        header: <span className='w-24'>Is Deleted</span>
      },
      {
        id: 'actions',
        cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} />,
        header: () => <span>Actions</span>,
      },
    ], []);

const handleInputChange = (e) => {
  setMessage(e.target.value);

  if (selectedUser) {
    socket.emit("adminTyping", {
      user_id: selectedUser.user_id,
      isTyping: true,
    });

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // new timeout to stop typing indicator after 1 second of inactivity
    typingTimeoutRef.current = setTimeout(() => {
      socket.emit("adminTyping", {
        user_id: selectedUser.user_id,
        isTyping: false,
      });
    }, 1000);
  }
};
    return (
      <Main crumbs={[{ title: "Users" }, { title: "User List" }]}>
        <CustomTable columns={columns} data={userListData} />
        <UsersForm defaultData={selectedUsers} fetchData={fetchData} />

        {/* Right-side Chat Window */}
        {isChatOpen && (
          <div className="fixed top-0 right-0 h-full w-80 bg-white shadow-xl border-l border-black z-50">
            <div className="bg-[rgb(249,176,60)] text-white p-3 flex justify-between items-center">
              <span>Chat with {selectedUser.name}</span>
              <button onClick={closeChat} className="text-white text-lg">
                ×
              </button>
            </div>

            <div className="h-[70%] overflow-y-auto p-3 bg-gray-50">
              {chatLoading ? (
                <p className="text-center text-gray-500">Loading messages...</p>
              ) : (
                messages.map((msg, index) => (
                  <div
                    key={index}
                    className={`p-2 my-1 text-sm rounded-lg max-w-[80%] ${
                      msg.isAdmin || msg.message_by === "admin"
                        ? "bg-[rgb(249,176,60)] text-white self-end ml-auto"
                        : "bg-gray-300 text-black self-start mr-auto"
                    }`}
                  >
                    {msg.message_by === "bot" && <strong>Bot: </strong>}
                    {msg.message}
                  </div>
                ))
              )}
              {userTyping && (
                <div className="p-2 my-1 text-sm rounded-lg max-w-[80%] bg-gray-200 text-black self-start mr-auto animate-pulse">
                  <strong>{selectedUser.name} </strong>is typing...
                </div>
              )}
              <div ref={chatRef}></div>
            </div>
            <div className="flex items-center border-t p-3 bg-gray-100">
              <input
                type="text"
                value={message}
                onChange={handleInputChange}
                className="flex-1 border p-2 rounded-md outline-none border-black"
                placeholder="Type your message..."
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              />
              <button
                onClick={sendMessage}
                className="ml-2 bg-[rgb(249,176,60)] text-white px-4 py-2 rounded-md border border-black hover:bg-opacity-90"
              >
                Send
              </button>
            </div>
          </div>
        )}
      </Main>
    );
};
